import React, { PropsWithChildren } from "react";

import identifiers from "@common/util/identifiers.json";

import * as Styled from "./CrashesPageNavigation.styles";

interface Props {
  crashTitle: string;
}

export default function CrashesPageNavigation({ children, crashTitle }: PropsWithChildren<Props>) {
  return (
    <Styled.CrashesNavigationWrapper>
      <Styled.CrashesNavigationTitle data-testid={identifiers["navbar.crashReport.detailsTitle"]}>
        {crashTitle}
      </Styled.CrashesNavigationTitle>
      {children}
    </Styled.CrashesNavigationWrapper>
  );
}
